import { ServiceCategory, ServiceItem } from 'orderme-api-integration-client';
import { IsSewingCompany } from './clientConfigs';

export const isGoodsCategory = (category: ServiceCategory) => {
  return category.itemsOnly;
};

export const isSewingService = (_service: ServiceItem) => {
  return IsSewingCompany;
};

export const isLaundryService = (_service: ServiceItem) => {
  return !IsSewingCompany;
};
